import React from 'react';
import ProjectSession from "../../../../model2/project/project-session"
import ProjectIconUI5 from "../project-icon-ui5";

type Props = {
    project?    : ProjectSession
    projectId?  : ID
    // color?      : number | 'disabled'       // I think number is not needed here and the only usage is disabled value
    color?      : 'disabled'       // I think number is not needed here and the only usage is disabled value
    colorize?   : boolean
    isExpanded? : boolean     // if true replace folder iwth open-folder
    className?  : string
}

export default class ProjectTypeIcon extends React.Component<Props> {


    getColorClass = () => {
        const project = (this.props.projectId)?gd.session.projects.get(this.props.projectId):this.props.project
        return 'gd-c-font-'+project!.color
    }

    render() {

        // patch
        if (this.props.color && this.props.color === 'disabled') {
            // @ts-ignore
            this.props.disabled = true
        }

        // we need it becasue of .gd-project-type-icon usage
        let classes = this.props.className || ''
        classes = classes + ' gd-project-type-icon'

        return <ProjectIconUI5 {...this.props} />




        /// OLD CODE


        // const project = this.props.projectId ? gd.session.projects.get(this.props.projectId) : this.props.project
        //
        // if (!project) {
        //     console.error("no project found in icon")
        //     return false
        // }
        //
        // if (!!EmojiDict[project.projectIcon]) {
        //     return <ProjectEmojiIcon emoji          = {project.projectIcon}
        //                              classes        = "w-15 m-r-12 fs-14 lh-14em"/>
        // }
        //
        // const systemType = project.systemType
        //
        // let colorClass
        // if (this.props.colorize) {
        //     colorClass = this.getColorClass()
        // }
        //
        // if (this.props.color && this.props.color === 'disabled') colorClass = 'color-disabled';
        //
        // let iconClass = (project.projectIcon) ?
        //     ProjectIconDictionary[project.projectIcon as keyof object]
        //     :
        //     // @ts-ignore
        //     ProjectIconDictionary[ProjectSystemTypeIcon[systemType]]
        //
        // // open folder patch
        // if (this.props.isExpanded && iconClass === 'ii5-folder') {
        //     iconClass = 'ii5-folder-open';
        // }
        //
        // const classes = Classes("gd-project-type-icon", iconClass,  colorClass, this.props.className);
        //
        // return <div className={classes}/>
    }
}
